export { View as LoanFormHint } from './view'
